import { render, staticRenderFns } from "./DeleteNote.vue?vue&type=template&id=477c8f9c"
import script from "./DeleteNote.vue?vue&type=script&lang=js"
export * from "./DeleteNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports